import classnames from 'classnames';
import { FC, useLayoutEffect, useRef } from 'react';

import type { IInputPanelProps } from '../Typeahead.models';

import './InputPanel.scss';

export const InputPanel: FC<IInputPanelProps> = (props: IInputPanelProps) => {
  const displaySpinner = props.displaySpinner !== false && props.fetchingResults;
  const inputRef = useRef<HTMLInputElement>(null);

  useLayoutEffect(() => {
    if (inputRef.current && props.isFocused) {
      inputRef.current.focus();
    }
  }, [props.isFocused]);
  return (
    <div className={`input-group input-group-${props.size ?? 'md'} ${props.hasError ? 'has-error' : ''}`}>
      <div className="text-primary">
        {displaySpinner ? (
          <span className="input-group-text">
            <span data-e2e="spinner" className="spinner spinner-sm" />
          </span>
        ) : (
          <span
            className={classnames('input-group-text', {
              'text-muted': props.isDisabled,
            })}
          >
            <i className="icon icon-xs">search</i>
          </span>
        )}
      </div>
      <input
        aria-label="Combobox"
        autoComplete="off"
        className={classnames(`form-control form-control-${props.size ?? 'md'} show`, {
          'is-warning': props.hasError,
          'border border-info': props.isLoading,
          'pe-none': props.isCellInactive,
        })}
        data-e2e={props.e2e ? props.e2e + '-input' : props.name + '-input'}
        disabled={props.isDisabled}
        id={props.id}
        name={props.name}
        onBlur={props.onInputBlur}
        onChange={props.onInputChange}
        onFocus={props.onInputFocus}
        onKeyDown={props.onInputKeyDown}
        placeholder={props.placeholder}
        readOnly={props.locked}
        required={props.required}
        tabIndex={props.tabIndex || 0}
        type="search"
        value={props.searchText}
        ref={inputRef}
      />
    </div>
  );
};
